import React, { useState } from "react";
import { login } from "../../../api";
import favicon32 from "../../../favicon-32.png";

export default function LoginView({ onLogin }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  async function handleSubmit(event) {
    event.preventDefault();
    setError("");
    setIsSubmitting(true);

    try {
      const authResponse = await login(email, password);
      onLogin(authResponse);
    } catch (err) {
      setError(err.message || "Login failed");
    } finally {
      setIsSubmitting(false);
    }
  }

  return (
    <main className="login-page">
      <form onSubmit={handleSubmit} className="login-card">
        <div className="login-header">
          <img
            src={favicon32}
            alt="AIOps"
            className="login-logo"
          />
          <div>
            <h1 className="login-title">AIOps</h1>
          </div>
        </div>

        <label htmlFor="email" className="login-label">
          Email
        </label>
        <input
          id="email"
          type="email"
          autoComplete="email"
          value={email}
          onChange={(event) => setEmail(event.target.value)}
          required
          className="login-input"
        />

        <label htmlFor="password" className="login-label">
          Password
        </label>
        <input
          id="password"
          type="password"
          autoComplete="current-password"
          value={password}
          onChange={(event) => setPassword(event.target.value)}
          required
          className="login-input"
        />

        {error && (
          <div role="alert" className="login-error">
            {error}
          </div>
        )}

        <button
          type="submit"
          disabled={isSubmitting}
          className="login-submit-btn"
        >
          {isSubmitting ? "Signing in..." : "Sign in"}
        </button>
      </form>
    </main>
  );
}
